import { Course } from '../../types';
import './CourseCard.css';

export const CourseCardProgress = (course: Course) => {
    return (
        <div className="card">
            <img src={course.image} alt={course.title} />

            <div className="info">
                <h3>{course.title}</h3>
                <p>{course.teacher}</p>
            </div>

            <div className="progress-container">
                <div className="progress">
                    <div 
                        className="progress-bar" 
                        style={{ width: `${course.progress}%` }}
                    ></div>
                </div>

                <p>{course.progress}% Progress</p>
            </div>
        </div>
    );
};

export const CourseCard = () => {
    return <div className="course-card"></div>;
};

export default CourseCard;